<script lang="ts">
    import {route} from './Nav'
    import {jwt, jwtPayload} from './Auth'
    import MainMenu from "./Component/MainMenu.svelte";

    $: userRoles = $jwtPayload?.owner?.role ?? []
    $: isQrExportOnly = userRoles.includes('qr_export') && !userRoles.includes('admin')
    $: isManagerOnlyRu = userRoles.includes('manager_only_ru') && !userRoles.includes('admin')
    // На чужому для ролі route не рендеримо сторінку (щоб вона не встигла смикнути заборонений
    // ендпоінт і отримати 403, через що authFetch одразу розлогінює), а лише редіректимо.
    $: isWrongRouteForRole = !!$route?.id && (
        (isQrExportOnly && $route.id !== 'QrLogin') ||
        (isManagerOnlyRu && !['Users', 'UserContacts', 'UserChats', 'User'].includes($route.id))
    )
    $: if ($jwt && isWrongRouteForRole) {
        location.hash = isQrExportOnly ? 'qrLogin' : 'users'
    }
    import Login from "./Component/Login.svelte";
    import Users from "./Page/Users.svelte";
    import UserChats from "./Page/UserChats.svelte";
    import UserContacts from "./Page/UserContacts.svelte";
    import UserName from "./Page/UserName.svelte";
    import User from "./Page/User.svelte";
    import Contact from "./Page/Contact.svelte";
    import AddUser from "./Page/AddUser.svelte";
    import Graph from "./Page/Graph.svelte";
    import Downloading from "./Overlay/Downloading.svelte";
    import Modal from "./Overlay/Modal.svelte"
    import UserContactsSearch from "./Page/UserContactsSearch.svelte";
    import UserMessageSearch from "./Page/UserMessageSearch.svelte";
    import SearchNearAddTask from "./Page/SearchNearAddTask.svelte";
    import SearchNearTaskList from "./Page/SearchNearTaskList.svelte";
    import SearchNearTask from "./Page/SearchNearTask.svelte";
    import AppList from "./Page/AppList.svelte";
    import BotList from "./Page/BotList.svelte";
    import ExportUserList from "./Page/ExportUserList.svelte";
    import QrLogin from "./Page/QrLogin.svelte";

    import {overlay} from "./Store";
    import {modal} from "./Store";

    const pages = {Users, UserChats, UserContacts, UserName, User, Contact, AddUser, Graph, UserContactsSearch, UserMessageSearch, SearchNearAddTask, SearchNearTaskList, SearchNearTask, AppList, BotList, ExportUserList, QrLogin}
    const overlays = {Downloading}
</script>
{#if $jwt}
    {#if $overlay!==null}
        <svelte:component this="{overlays[$overlay]}"/>
    {:else if isWrongRouteForRole}
        <!-- редірект на дозволений route ще не відпрацював, сторінку не рендеримо -->
    {:else}
        <Modal show={$modal}>
            <MainMenu/>
            <svelte:component this="{pages[$route.id]}" params={$route.params}/>
        </Modal>
    {/if}
{:else}
    <Login/>
{/if}
